import { Reveal } from "@/components/motion";

export function Eyebrow({ children, className = "" }) {
  return (
    <span className={`eyebrow inline-flex items-center gap-2 text-primary ${className}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-primary" />
      {children}
    </span>
  );
}

export function SectionHeading({ eyebrow, title, subtitle, align = "left", className = "" }) {
  const alignCls = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <Reveal className={`flex max-w-2xl flex-col gap-4 ${alignCls} ${className}`}>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h2 className="font-display text-3xl font-semibold leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl">
        {title}
      </h2>
      {subtitle && <p className="text-base text-muted-foreground sm:text-lg">{subtitle}</p>}
    </Reveal>
  );
}

const TONES = {
  soon: "bg-brand-teal/12 text-brand-teal ring-1 ring-brand-teal/25",
  dev: "bg-brand-blue/12 text-brand-blue ring-1 ring-brand-blue/25 dark:text-blue-400",
  future: "bg-muted text-muted-foreground ring-1 ring-border",
};
const LABELS = { soon: "Available Soon", dev: "In Development", future: "Future" };

export function StatusBadge({ status, className = "" }) {
  return (
    <span
      data-testid={`module-status-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold ${TONES[status]} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {LABELS[status]}
    </span>
  );
}

export function Marquee({ items }) {
  const doubled = [...items, ...items];
  return (
    <div className="marquee-track relative w-full overflow-hidden py-2">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-background to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-background to-transparent" />
      <div className="flex w-max animate-marquee items-center gap-10">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center gap-10 text-xl font-medium text-muted-foreground sm:text-2xl">
            <span className="font-display tracking-tight">{item}</span>
            <span className="text-primary">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
